import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=763b568e&scoped=true"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./ThankYou.vue?vue&type=style&index=0&id=763b568e&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "763b568e",
  "885314aa"
  
)

export default component.exports